module.exports = __webpack_public_path__ + "static/media/home.a5b965f2.jpg";